<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :loading="loading"
    :items="marks"
    :items-per-page="10"
    :mobile-breakpoint="900"
    :footer-props="{ 'items-per-page-text': 'Số kỳ kiểm tra mỗi trang' }"
    v-bind="this.$attrs"
  >
    <template v-slot:[`footer.page-text`]="items">
      Kỳ kiểm tra thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} kỳ kiểm tra
    </template>
    <template v-slot:[`item.mark`]="{ item }">
      <div style="height: 100%; ">
        <ReviewResultCard :item="item" />
      </div>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.exam.name }}
      </div>
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.student.dob | getDate }}
      </div>
    </template>
    <template v-slot:[`item.student`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        <StudentExamCard :student="item.student" />
      </div>
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item | getStatus }}
      </div>
    </template>
    <template v-slot:[`item.examCode`]="{ item }">
      <div style="height: 100%; display: flex; align-items: flex-start; padding-top: 10px">
        {{ item.examCode }}
      </div>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div style=" height: 100% ;display: flex; align-items: flex-start; padding-top: 10px">
            <v-btn
              v-on="on"
              @click="openLink(item)"
              icon
              :disabled="!item.exam || !item.exam.files2 || !item.exam.files2.length || !item.exam.files2[0].url"
            >
              <v-icon center color="grey darken-1">mdi-printer</v-icon>
            </v-btn>
          </div>
        </template>
        <span>In đơn phúc khảo</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import ReviewResultCard from './ReviewResultCard.vue'
import StudentExamCard from '../../../components/basic/card/StudentExamCard.vue'

const originHeaders = [
  {
    text: 'PK tại kỳ kiểm tra',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Số báo danh',
    value: 'examCode',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Trạng thái đơn PK',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Kết quả PK',
    value: 'mark',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]

export default {
  props: {
    exams: Array,
    marks: Array
  },
  components: { ReviewResultCard, StudentExamCard },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },
  created() {},
  watch: {},
  methods: {
    openLink(item) {
      window.open(item.exam.files2[0].url, '_blank')
    }
  },
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'notSeen') {
        return 'Chưa duyệt'
      } else if (item.status === 'hasResult') {
        return 'Đã có kết quả'
      } else if (item.status === 'approved') {
        return 'Đã duyệt'
      } else {
        return ''
      }
    },
    getDate: item => {
      if (item) {
        return moment(item)
          .utcOffset(7)
          .format('DD/MM/YYYY')
      }
      return 'Chưa có thông tin'
    }
  }
}
</script>
